import type { PlantWithId } from '../../types/plant';

interface UndoDialogProps {
  isOpen: boolean;
  plant: PlantWithId;
  onUndo: () => void;
  onClose: () => void;
}

export function UndoDialog({ isOpen, plant, onUndo, onClose }: UndoDialogProps) {
  if (!isOpen) return null;

  const displayName = plant.nickname || plant.commonName;

  const handleUndo = () => {
    onUndo();
    onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="undo-dialog-title"
    >
      <div
        className="w-full max-w-sm rounded-lg bg-white border border-gray-200 p-6 shadow-elevated"
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          id="undo-dialog-title"
          className="text-lg font-display font-bold text-editorial-black"
        >
          Undo Watering?
        </h2>
        <p className="mt-2 font-serif text-gray-500">
          Revert <span className="font-medium text-editorial-black">{displayName}</span> to previous watering date?
        </p>
        <div className="mt-6 flex gap-3">
          <button
            onClick={onClose}
            className="h-12 flex-1 rounded-lg border border-gray-300 px-4 font-sans font-bold text-xs uppercase tracking-widest text-editorial-black transition-colors hover:border-gray-500"
          >
            Cancel
          </button>
          <button
            onClick={handleUndo}
            className="h-12 flex-1 rounded-lg bg-editorial-black px-4 font-sans font-bold text-xs uppercase tracking-widest text-white transition-colors hover:bg-black"
          >
            Undo
          </button>
        </div>
      </div>
    </div>
  );
}
